import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';

import Sort from '../../sort/Sort';
import Pagination from '../../pagination/Pagination';

import styles from './Controls.module.scss';
import { ProductCardToggles } from './ProductCardToggles';
import { useExperiencesContext } from '../../experiences/Experiences';
import { useFacetContext } from '../../../context/FacetContext';

const Controls = ({
  handleSelect,
  sortBy,
  pages,
  current,
  handleFilterDrawerClick,
}) => {
  const { isProductCardSizeFlagOn, isListViewOn } = useExperiencesContext();
  const { isPrimaryFacetInDiscoResponse: isMoreFiltersButton } =
    useFacetContext();

  const testId = isMoreFiltersButton ? 'more-filters-button' : 'filters-button';

  return (
    <>
      <SecondaryButton
        className={styles['filter-drawer-button']}
        data-test={testId}
        onClick={handleFilterDrawerClick}
      >
        Filter
      </SecondaryButton>
      <Sort onSelect={handleSelect} sort={sortBy} />
      {isProductCardSizeFlagOn && !isListViewOn && <ProductCardToggles />}
      <div className={styles['align-right']}>
        <Pagination
          current={parseInt(current, 10)}
          pages={pages}
          aria-label="Product listing page pagination"
        />
      </div>
    </>
  );
};

Controls.defaultProps = {
  sortBy: '',
  pages: 1,
  current: '1',
  handleFilterDrawerClick: () => {},
};

Controls.propTypes = {
  sortBy: PropTypes.string,
  pages: PropTypes.number,
  current: PropTypes.string,
  handleFilterDrawerClick: PropTypes.func,
};

export default memo(Controls);
